import { useAbmApi2 as initApi } from '../../app/services/ApiService';
import { useAbmApiWithCancelToken as initApiWithCancelToken } from '../../app/services/ApiService';

import { abmConstants } from '../constants';
import { baseAction, toDispatch } from '../utils';

/**
 * @param {*} controller string | nombre del controller en la api 
 * @returns 
 */

const abmActions = (controller) => {

  const constants = abmConstants(controller);
  const api = initApi(controller);

  //const cancel = () => (dispatch, getState) => {
    //api(getState).cancel();
    //dispatch(toDispatch(constants.FETCH_CANCEL))
  //}


  const getSchema = (tabla) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).schema(tabla),
      ...tabla ? constants.SCHEMA_FORM : constants.SCHEMA,
      dispatch,
      getState
    });
  }

  const index = (pageSize) => (dispatch, getState) => {
    return baseAction({
      fn: () => api( getState).index(1, pageSize),
      ...constants.INDEX,
      dispatch,
      getState
    });
  }

  const loadMore = (page, pageSize) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).index(page, pageSize),
      ...constants.LOAD_MORE,
      dispatch,
      getState
    });
  }
  
  const updateLocalItem = (item) => (dispatch, getState) => {
    dispatch(toDispatch(constants.INDEX.UPDATE_ITEM, item))
    dispatch(toDispatch(constants.FILTER.UPDATE_ITEM, item))
  }
  
  const addLocalItem = (item) => (dispatch, getState) => {
    dispatch(toDispatch(constants.INDEX.ADD_ITEM, item))
  }

  const filter = (term) => (dispatch, getState) => {
    if(term.length < 1){
      dispatch(toDispatch(constants.FILTER.CLEAR))
      return new Promise((resolve) => resolve(null));
    }else{
      return baseAction({
        fn: () => api(getState).filter(term),
        ...constants.FILTER,
        dispatch,
        getState
      });  
    }

  }

  const setSearchTerm = (term) => (dispatch, getState) => {
    dispatch(toDispatch(constants.SET_SEARCH_TERM, term))
  }

  const basicIndex = () => (dispatch, getState) => {
    return baseAction({
      fn: api(getState).basicIndex,
      ...constants.INDEX,
      dispatch,
      getState
    });
  }

  const getItem = (id) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getItem(id),
      ...constants.GET_ITEM,
      dispatch,
      getState
    });
  }

  const addForm = () => (dispatch, getState) => {
    return baseAction({
      fn: api(getState).addForm,
      ...constants.ADD_FORM,
      dispatch,
      getState
    });
  }

  const editForm = (id) => (dispatch, getState) => {
    const loadApi = initApiWithCancelToken(controller);
    return baseAction({
      fn: () => loadApi.init(getState).editForm(id),
      ...constants.EDIT_FORM,
      dispatch,
      getState,
      cancel: loadApi.cancel,
    });
  }

  const addItem = (data, section) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).addItem(data, section),
      ...(section ? constants.ADD_ITEM_SECTION : constants.ADD_ITEM),
      dispatch,
      getState
    });
  }

  const editItem = (id, data, section) => (dispatch, getState) => {
    //console.log("abmActions.editItem", {id, data, section, dispatch, getState})
    return baseAction({
      fn: () => api(getState).editItem(id, data, section),
      ...(section ? constants.EDIT_ITEM_SECTION : constants.EDIT_ITEM),
      dispatch,
      getState
    });
  }

  const removeItem = (data, section) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).removeItem(data, section),
      ...(section ? constants.REMOVE_ITEM_SECTION : constants.REMOVE_ITEM),
      dispatch,
      getState
    });
  }

  const getTable = (id) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getTable(id),
      ...constants.GET_TABLE,
      dispatch,
      getState
    });
  }

  const getTimeline = (id) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getTimeline(id),
      ...constants.GET_TIMELINE,
      dispatch,
      getState
    });
  }

  const getEnum = (campo, tabla) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getEnum(campo, tabla),
      ...constants.GET_ENUM,
      dispatch,
      getState
    });
  }

  const getNodeTypes = () => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getNodeTypes(),
      ...constants.GET_NODE_TYPES,
      dispatch,
      getState
    });
  }

  const getFlow = (idOperacion) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getFlow(idOperacion),
      ...constants.GET_FLOW,
      dispatch,
      getState
    });
  }

  const getFlowOutputs = (data) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getFlowOutputs(data),
      ...constants.GET_FLOW_OUTPUTS,
      dispatch,
      getState
    });
  }

  const postFlow = (idOperacion, data) => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).postFlow(idOperacion, data),
      ...constants.POST_FLOW,
      dispatch,
      getState
    });
  }

  const getConectionTypes = () => (dispatch, getState) => {
    return baseAction({
      fn: () => api(getState).getConectionTypes(),
      ...constants.GET_CONECTION_TYPES,
      dispatch,
      getState
    });
  }

  const loadedProcessed = () => (dispatch, getState) => {
    dispatch(toDispatch(constants.LOADED_PROCESSED))
  }

  const setSelectedTab = (tab) => (dispatch, getState) => {
    dispatch(toDispatch(constants.SET_SELECTED_TAB, tab))
  }

  const setNoSavedChanges = (value) => (dispatch, getState) => {
    dispatch(toDispatch(constants.SET_NO_SAVED_CHANGES, value))
  }

  const saveFlow = (data) => (dispatch, getState) => {
    dispatch(toDispatch(constants.SAVE_FLOW, data))
  }

  const keyValues = ({key, data}) => (dispatch, getState) => {

    const create = () => {
      return baseAction({
        fn: () => api(getState).keyValueCreate(key, data),
        ...constants.KEY_VALUE,
        dispatch,
        getState
      });
    }
    const store = () => {
      return baseAction({
        fn: () => api(getState).keyValueStore(data),
        ...constants.KEY_VALUE,
        dispatch,
        getState
      });
    }
    const update = () => {
      return baseAction({
        fn: () => api(getState).keyValueUpdate(key, data),
        ...constants.KEY_VALUE,
        dispatch,
        getState
      });
    }
    const remove = () => {
      return baseAction({
        fn: () => api(getState).keyValueDelete(key),
        ...constants.KEY_VALUE,
        dispatch,
        getState
      });
    }
    const get = () => {
      return baseAction({
        fn: () => api(getState).keyValueGet(key),
        ...constants.KEY_VALUE,
        dispatch,
        getState
      });
    }

    return {create, store, update, remove, get}
  }

  return {
    index,
    basicIndex,
    getItem,
    addItem,
    editItem,
    addForm,
    editForm,
    removeItem,
    loadedProcessed,
    getTable,
    getTimeline,
    getEnum,
    filter,
    loadMore,
    updateLocalItem,
    addLocalItem,
    getSchema,
    keyValues,
    setSelectedTab,
    setNoSavedChanges,
    getNodeTypes,
    getFlow,
    getFlowOutputs,
    getConectionTypes,
    postFlow,
    saveFlow,
    setSearchTerm
    //cancel,
  };

}

export default abmActions;